[
    {
        "display": "true",
        "ui_columnname": "action",
        "db_columnname": "modifiedFlag",
        "datatype": "char",
        "mappingkey": "modifiedFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "true",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Exception",
        "db_columnname": "Exception_Description",
        "datatype": "String",
        "mappingkey": "Exception_Description",
        "dropdown": "YES",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": [
            {
                "value": "0001",
                "label": "Odd Lot Fail to Aggregate"
            },
            {
                "value": "0002",
                "label": "Odd Lot Fail to Aggregate Routes"
            },
            {
                "value": "0003",
                "label": "Spoofing"
            },
            {
                "value": "0010",
                "label": "Layering"
            },
            {
                "value": "0004",
                "label": "Wash Orders"
            },
            {
                "value": "0005",
                "label": "Wash Route"
            },
            {
                "value": "0006",
                "label": "Insider Trading"
            },
            {
                "value": "0007",
                "label": "Marking Close - Ramping"
            },
            {
                "value": "0008",
                "label": "Marking Close - Downward"
            },
            {
                "value": "0009",
                "label": "Marking Close - Rate"
            }
        ]
    },
    {
        "display": "false",
        "ui_columnname": "Exception Type",
        "db_columnname": "Exceptiongrpname",
        "datatype": "String",
        "mappingkey": "Exceptiongrpname",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Symbol",
        "db_columnname": "Symbol",
        "datatype": "String",
        "mappingkey": "Symbol",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Side",
        "db_columnname": "BuySellCode",
        "mappingkey": "BuySellCode",
        "isdefault":  "false",
        "disabled": "false",
        "dropdown": "YES",
        "value": "Enter Value",
        "dropdowntype": "singleselect",
        "dropdownvalue": [
            {
                "label": "None",
                "value": ""
            },
            {
                "label": "B-(buy)",
                "value": "B"
            },
            {
                "label": "SL-(sell long)",
                "value": "SL"
            },
            {
                "label": "SS-(short sale)",
                "value": "SS"
            },
            {
                "label": "SX-(short sale exempt)",
                "value": "SX"
            }
        ]
    },
    {
        "display": "false",
        "ui_columnname": "Ord Qty",
        "db_columnname": "Quantity",
        "datatype": "Int",
        "mappingkey": "Quantity",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Ord Price",
        "db_columnname": "LimitPrice",
        "datatype": "Int",
        "mappingkey": "LimitPrice",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Min Trade Price",
        "db_columnname": "MinTradePrice",
        "datatype": "Int",
        "mappingkey": "MinTradePrice",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Max Trade Price",
        "db_columnname": "MaxTradePrice",
        "datatype": "Int",
        "mappingkey": "MaxTradePrice",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Cumulative Qty",
        "db_columnname": "CumulativeQty",
        "datatype": "Int",
        "mappingkey": "CumulativeQty",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Count",
        "db_columnname": "TransCount",
        "datatype": "Int",
        "mappingkey": "TransCount",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Contra ID",
        "db_columnname": "ContraID",
        "datatype": "String",
        "mappingkey": "ContraID",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Route ID",
        "db_columnname": "RouteID",
        "datatype": "String",
        "mappingkey": "RouteID",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Received From MPID",
        "db_columnname": "ReceivedFromMPID",
        "datatype": "String",
        "mappingkey": "ReceivedFromMPID",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Status",
        "db_columnname": "Status",
        "mappingkey": "Status",
        "isdefault":  "false",
        "disabled": "false",
        "dropdown": "YES",
        "value": "Enter Value",
        "dropdowntype": "singleselect",
        "dropdownvalue": [
            {
                "label": "None",
                "value": ""
            },
            {
                "label": "Close",
                "value": "close"
            },
            {
                "label": "Open",
                "value": "open"
            },
            {
                "label": "ReOpen",
                "value": "reopen"
            }
        ]
    },
    {
        "display": "true",
        "ui_columnname": "Owner",
        "db_columnname": "Owner",
        "datatype": "String",
        "mappingkey": "Owner",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Comments",
        "db_columnname": "Comments",
        "datatype": "String",
        "mappingkey": "Comments",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Date Time",
        "db_columnname": "StartDateTime",
        "datatype": "String",
        "mappingkey": "StartDateTime",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Contra Acct",
        "db_columnname": "ContraAcct",
        "datatype": "String",
        "mappingkey": "ContraAcct",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Order Desk",
        "db_columnname": "OrderDesk",
        "datatype": "String",
        "mappingkey": "OrderDesk",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Trader Account",
        "db_columnname": "TraderAccount",
        "datatype": "Int",
        "mappingkey": "TraderAccount",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "OMS System",
        "db_columnname": "OMSSystem",
        "datatype": "String",
        "mappingkey": "OMSSystem",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Trader ID",
        "db_columnname": "TradeID",
        "datatype": "Int",
        "mappingkey": "TradeID",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Trade Price",
        "db_columnname": "TradePrice",
        "datatype": "Int",
        "mappingkey": "TradePrice",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Trader Qty",
        "db_columnname": "TradeQuantity",
        "datatype": "Int",
        "mappingkey": "TradeQuantity",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Trade Bid",
        "db_columnname": "TrdBid",
        "datatype": "Int",
        "mappingkey": "TrdBid",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Trade Ask",
        "db_columnname": "TrdAsk",
        "datatype": "Int",
        "mappingkey": "TrdAsk",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Order ID",
        "db_columnname": "OrderID",
        "datatype": "String",
        "mappingkey": "OrderID",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Firm MPID",
        "db_columnname": "FirmMPID",
        "datatype": "String",
        "mappingkey": "FirmMPID",
        "dropdown": "NO",
        "isdefault":  "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }
]